module.exports = __webpack_public_path__ + "img/uyuni.3378eb99.jpg";